import type { JobSummaryViewModel } from './job-summary.view-model';

export const getJobIdentifier = (job: JobSummaryViewModel) => {
  switch (job.type) {
    case 'ATS_RAW':
      return job.jobAtsId ?? '';
    case 'INDEED':
      return job.jobIndeedId ?? '';
    default:
      return job.dbId?.toString() ?? '';
  }
};
